<template>
<div>
  <matter-add-matter-type-form ref="matterAddMatterTypeModal" :lawMatterId="lawMatterId" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-add-matter-type-form>
   <matter-smuggling-form ref="matterSmugglingFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-smuggling-form>
   <matter-consulting-form ref="matterConsultingFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-consulting-form>
   <matter-customs-registration-form ref="matterCustomsRegistrationFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-customs-registration-form>
   <matter-stop-customs-form ref="matterStopCustomsFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-stop-customs-form>
   <matter-evidence-detection-form ref="matterEvidenceDetectionFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-evidence-detection-form>
   <matter-mediation-form ref="matterMediationFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-mediation-form>
   <matter-matter-info-form ref="matterMatterInfoFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-matter-info-form>
   <matter-legal-notice-form ref="matterLegalNoticeFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-legal-notice-form>
   <matter-simplified-destruction-form ref="matterSimplifiedDestructionFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-simplified-destruction-form>
    <div class="d-flex justify-content-between align-items-center"  >
         <h4 class="card-title">{{ $t('others.process') }}</h4>
        <b-button size="sm" variant="outline-primary" class="mb-2" @click="showModal()" >{{ $t('others.new_process') }}</b-button>
    </div>
   
  <vue-good-table 
      id="matterTypeHistoryTable"
      ref="matterTypeHistoryTable" 
      :columns="columns" 
      :rows="rows" 
      styleClass="vgt-table condensed tableSize" 
      :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }" 
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true,
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, 
        selectAllByGroup: true,
      }" 
      :pagination-options="{
        enabled: true,
        perPage: pageLength
      }" theme="my-theme">
        <div slot="emptystate">
          {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
          <span v-if="props.column.field === 'recordDate'" class="text-nowrap">
            {{ $t('lawMatterTypeHistory.record_date') }}
          </span>
           <span v-if="props.column.field === 'lawMatterTypeName'" class="text-nowrap">
            {{ $t('lawMatterTypeHistory.law_matter_process_type') }}
          </span>
            <span v-if="props.column.field === 'employeeName'" class="text-nowrap">
            {{ $t('lawMatterTypeHistory.employee') }}
          </span>
          <span v-else-if="props.column.field === 'process'" class="text-nowrap">
            {{ $t('others.process') }}
          </span>       
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
          <!-- Column: Process -->
            <span v-if="props.column.field === 'process'">
                <span>
                <b-button v-b-tooltip.html :title="$t('others.edit')" v-b-modal.modal-top variant="primary"
                    class="btn-icon mb-1 ml-1" size="sm" @click="getInfo(props.row.lawMatterTypeId,props.row.recordId,props.row.employeeId,props.row.id)">
                    <feather-icon icon="EditIcon" />
                </b-button>
                </span>
            </span>
        </template>
  
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ props.total }} {{ $t('dataTable.record') }}
              </span>
              <b-form-select v-model="pageLength" :options="['10', '50', '100', '1000']" class="mx-1"
                @input="(value) => props.perPageChanged({ currentPerPage: value })" />
              <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
            </div>
            <div>
              <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number
                align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>   
</div>
</template>

<script>

export default {
    
    props:{
      lawMatterId: {type: Number}
    },
    data() {
        return {
            pageLength: 10,
            dir: false,
            columns: [
            {
                label: this.$t('lawMatterTypeHistory.record_date'),
                field: `recordDate`,
                formatFn: this.$formatFn
            },
            {
               label: this.$t('lawMatterTypeHistory.law_matter_process_type'),
               field: 'lawMatterTypeName'
            },
            {
               label: this.$t('lawMatterTypeHistory.employee'),
               field: 'employeeName'
            },
            {
                label: 'Process',
                field: 'process',
                width: '7em'
            },
            ],
            rows: [],
            searchTerm: '',
        }
    }, 
    mounted() {
        this.getMatterTypeHistoryList()
    },
    methods:{
        showModal(){
          this.$refs.matterAddMatterTypeModal.showInfo();
        },
        getMatterTypeHistoryList(){
           const controller = {name: 'LawMatterMatterTypeHistory',actionName: 'GetLawMatterMatterTypeHistoryListByLawMatterId'}
           this.rows = [];
            const data = {
                id: this.lawMatterId
            }
             const payload = {
                controller: controller,
                data: data
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.rows = response.data.lawMatterMatterTypeHistoryList
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            });
        },
        getInfo(lawMatterTypeId,recordId,employeeId,id){
            switch(lawMatterTypeId){
              case 1: this.$refs['matterMatterInfoFormModal'].showMatterInfo(recordId,this.lawMatterId); break;
              case 2: this.$refs['matterConsultingFormModal'].showConsulting(recordId,this.lawMatterId); break;
              case 3: this.$refs['matterCustomsRegistrationFormModal'].showCustomsRegistration(recordId,this.lawMatterId,employeeId); break;
              case 4: this.$refs['matterStopCustomsFormModal'].showStopCustoms(recordId,this.lawMatterId); break;
              case 5: this.$refs['matterEvidenceDetectionFormModal'].showEvidenceDetection(recordId,this.lawMatterId); break;
              case 7: this.$refs['matterSmugglingFormModal'].showSmuggling(recordId,this.lawMatterId); break;
              case 8: this.$refs['matterLegalNoticeFormModal'].showLegalNotice(recordId,this.lawMatterId); break;
              case 9: this.$refs['matterSimplifiedDestructionFormModal'].showSimplifiedDestruction(recordId,this.lawMatterId); break;
              case 10 : this.$refs['matterMediationFormModal'].showMediation(recordId,this.lawMatterId,employeeId,id); break;
            }
        }
    }
    
}
</script>

<style lang="scss">
</style>
